import { useEffect, useState } from "react";
import { CloseSvg } from "../icons/Icon";

const ExpandableTokens = (p) => {

    const [list, setList] = useState([]);

    useEffect(() => {
        setList(p.list);
    }, [p.list]);

    return (
        <div className="ExpandableTokens">
            <div className="ExpandableTokens_slot">
                <ul>
                    {Array.isArray(list) && list.map((item, index) => {
                        return (
                            <li key={`li-${item.id}`} className={`ExpandableTokens_token ${(index > (p.show || 2)) ? 'bidden' : ''}`}><span>{item.name}</span><figure><CloseSvg /></figure></li>
                        )
                    })}
                </ul>
            </div>
        </div>
    );
};

export default ExpandableTokens;